export default "__VITE_ASSET__DUueUCgR__"